<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Ürün Listesi">
          <!-- <b-alert variant="warning" show class="mb-0">
                <div class="alert-body mb-2">
                  <span
                    ><strong>Not:</strong> Eklenecek içerik adı ve arama motoru
                    bağlantı linki benzersiz olmalıdır...</span
                  >
                </div>
              </b-alert> -->
          <b-button
            class="float-right"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            :to="`/product/create`"
          >
            Yeni Ürün Ekle
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Ürünler">
          <b-form>
            <b-row>
              <b-col cols="12">
                <table class="table b-table table-responsive">
                  <thead>
                    <th>#</th>
                    <th>GÖRSEL</th>
                    <th>ÜRÜN ADI</th>
                    <th>DURUM</th>
                    <th>ÇEVİRİLER</th>
                    <th>OLUŞTURMA TARİHİ</th>
                    <th>İŞLEMLER</th>
                  </thead>
                  <draggable
                    v-model="products"
                    class="cursor-move"
                    tag="tbody"
                    @change="outputData"
                  >
                    <tr v-for="product in products" :key="products.id">
                      <td>{{ product.id }}</td>
                      <td>
                        <b-img :src="product.images.productImage" width="32" />
                      </td>
                      <td>{{ product.name }}</td>
                      <td class="text-center">
                        <b-badge v-if="product.isDraft" variant="light-warning">
                          Pasif
                        </b-badge>
                        <b-badge v-else variant="light-success"> Aktif </b-badge>
                      </td>

                      <td>
                        <b-button-group class="mr-2">
                          <b-button
                            v-for="language in languages"
                            :key="language.code"
                            @click="action(product, language.code)"
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            :variant="
                              product.languages.find(
                                (element) => element == language.code
                              )
                                ? 'outline-warning'
                                : 'outline-secondary'
                            "
                            :title="
                              product.languages.find(
                                (element) => element == language.code
                              )
                                ? 'Düzenle'
                                : 'Ekle'
                            "
                          >
                            {{ language.code.toUpperCase() }}
                          </b-button>
                        </b-button-group>
                      </td>
                      <td>{{ product.createdAt }}</td>

                      <td>
                        <b-button-group class="float-right">
                          <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-danger"
                            class="btn-icon rounded-circle"
                            @click="deleteConfirmText(product.id)"
                          >
                            <feather-icon icon="TrashIcon" /> </b-button
                        ></b-button-group>
                      </td>
                    </tr>
                  </draggable>
                  <thead>
                    <th>#</th>
                    <th>GÖRSEL</th>
                    <th>ÜRÜN ADI</th>
                    <th>DURUM</th>
                    <th>ÇEVİRİLER</th>
                    <th>OLUŞTURMA TARİHİ</th>
                    <th>İŞLEMLER</th>
                  </thead>
                </table>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Ripple from "vue-ripple-directive";
import draggable from "vuedraggable";
import {
  BRow,
  BCol,
  BImg,
  BCard,
  BForm,
  BBadge,
  BAlert,
  BButton,
  BAvatar,
  BCardText,
  BButtonGroup,
  BListGroupItem,
  BButtonToolbar,
} from "bootstrap-vue";
import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BCard,
    BForm,
    BAlert,
    BBadge,
    BButton,
    BAvatar,
    BCardText,
    BButtonGroup,
    BListGroupItem,
    BButtonToolbar,
    draggable,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      request: [],
      products: [],
      languages: [],
    };
  },
  watch: {},
  methods: {
    action(node, locale) {
      let translationControl = node.languages.find((element) => element == locale);

      console.log(translationControl);
      if (translationControl === undefined) {
        this.$router.push({
          path: `/product/translation/create/${node.id}?targetLocale=${locale}`,
        });
      } else {
        this.$router.push({
          path: `/product/translation/edit/${node.id}?targetLocale=${locale}`,
        });
      }
    },

    outputData() {
      this.updateSubmit();
    },
    updateSubmit() {
      Object.entries(this.products).forEach(([key, value]) => {
        let productsOrder = {
          id: value.id,
          order: parseInt(key),
        };
        this.request.push(productsOrder);
      });
      endpoints
        .putProductsOrder({ products: this.request }, this.$i18n.locale, () => {})
        .then((data) => {
          this.$swal({
            icon: "success",
            title: "Güncelleme başarılı!",
            text: "Ürün sıralaması güncellendi.",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getProducts() {
      endpoints
        .getProducts(null, this.$i18n.locale, () => {})
        .then((data) => {
          this.products = [...data.response];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getLanguages() {
      endpoints
        .getLanguages(null, this.$i18n.locale, () => {})
        .then((data) => {
          this.languages = [...data.response];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteConfirmText(id) {
      this.$swal({
        title: "Sil?",
        text: "Ürünü silmek istediğinize emin misiniz?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Vazgeç!",
        confirmButtonText: "Kaydet!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteSubmit(id);
        }
      });
    },
    deleteSubmit(id) {
      endpoints
        .deleteProduct(id, this.$i18n.locale, () => {})
        .then((data) => {
          this.getProducts();
          this.$swal({
            icon: "success",
            title: "Silme başarılı!",
            text: "Ürün silindi",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.getLanguages();
    this.getProducts();
  },
};
</script>
<style>
.draggable-card {
  margin-bottom: 0;
}

.draggable-card > .card-body {
  padding: 10px;
}

.draggable-card > .card-body > .card-title {
  margin-bottom: 0;
  font-size: 1rem;
}

.tree-node {
  border: 0 !important;
}
</style>
